export default __webpack_public_path__ + "static/media/roofing.a71d8e58.mp4";